import {resetNoteFolderIdEmpty} from "@model/note";

let folder;

export function initFolder(db){
    folder = db.table('folder');
}

export function allFolder(){
    return folder.toArray();
}

export function getFolderById(id){
    return folder.get(id);
}

export function updateFolder(data){
    return folder.put(data);
}

/*删除这个文件夹，并删除所有笔记与之关联的folderId*/
export function deleteFolder(id){
    return new Promise((resolve, reject) => {
        folder.delete(id).then(async res => {
            await resetNoteFolderIdEmpty(id);
            resolve();
        })
    })
}